import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/language";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import DesignSystem from "@/pages/DesignSystem";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PreviewOnly({ children, login = false }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  if (window.CSAI_PREVIEW_OWNER || (login && query.get("preview") === "1" && query.get("mode") !== "signup")) return children;
  return <main className="mx-auto max-w-xl p-12"><h1>Private preview</h1><p>This section is not publicly available yet.</p><a href="/">Return home</a></main>;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<PreviewOnly login><Auth /></PreviewOnly>} />
            <Route path="/onboarding" element={<PreviewOnly><Onboarding /></PreviewOnly>} />
            <Route path="/dashboard" element={<PreviewOnly><Dashboard /></PreviewOnly>} />
            <Route path="/inbox" element={<PreviewOnly><Inbox /></PreviewOnly>} />
            <Route path="/design-system" element={<PreviewOnly><DesignSystem /></PreviewOnly>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
